import React, { useState } from 'react';
import './manageItemUpdatedData.css';
import { useNavigate } from 'react-router-dom';

const ManageItemUpdatedData = () => {
  const [title, setTitle] = useState('');
  const [graphType, setGraphType] = useState('Only Table');
  const [file, setFile] = useState(null);

  const navigate = useNavigate();

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleGraphTypeChange = (e) => {
    setGraphType(e.target.value);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = (e) => {
    e.preventDefault();
    // Handle file upload logic here
    console.log({ title, graphType, file });
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  const handleAddItemClick = () => {
    navigate('/inneritems'); // Navigate to the inner items page
  };

  return (
    <div className="formContainer">
      <div className="header">
        <h2>Uploaded Items Data</h2><br />
        <div className="buttons">
          <button className="addItemButton" onClick={handleAddItemClick}>+ Add Item / View Item</button>
          <button className="backButton" onClick={handleBackClick}>Back</button>
        </div>
      </div>
      <form className="uploadForm" onSubmit={handleUpload}>
        <div className="formGroup">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={handleTitleChange}
            placeholder="Title"
          />
        </div>
        <div className="formGroup">
          <label htmlFor="graphType">Graph Type</label>
          <select id="graphType" value={graphType} onChange={handleGraphTypeChange}>
            <option value="Only Table">Only Table</option>
            <option value="Bar Graph">Bar Graph</option>
            <option value="Line Graph">Line Graph</option>
            <option value="Pie Chart">Pie Chart</option>
          </select>
        </div>
        <div className="formGroup">
          <label htmlFor="file">Excel Upload</label>
          <div className="fileInputWrapper">
            <input type="file" id="file" onChange={handleFileChange} />
            <label htmlFor="file" className="customFileInput">
              Choose File
            </label>
            {file && <span className="fileName">{file.name}</span>}
          </div>
        </div>
        <button type="submit" className="uploadButton">Upload</button>
      </form>
    </div>
  );
};

export default ManageItemUpdatedData;
